
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return require("next/dist/pages/_app");
      }
    ]);
  